import { Box, Container, Grid, useTheme } from "@mui/material";
import { Menu } from "./menu";
import { Payments } from "./payments";
import { Section } from "./section";
import React from "react";
export const Footer = ({ menus = [], showPayments = true, sx = {} }) => {
    const theme = useTheme();
    const size = Math.floor(12 / menus.length);
    return (React.createElement("footer", null,
        React.createElement(Box, { sx: {
                background: theme.palette.primary.main,
                pb: { xs: 4, sm: 8, md: 10, xl: 20 },
                pt: { xs: 10, sm: 10, md: 12, xl: 20 },
                width: "100%",
                ...sx,
            } },
            React.createElement(Container, null,
                React.createElement(Grid, { alignItems: "start", columnSpacing: { sm: 6, md: 8, lg: 12 }, container: true, rowSpacing: { xs: 6, sm: 14 } },
                    menus.map(({ title, items }, ix) => (React.createElement(Grid, { key: `footer-menu-${ix}`, item: true, xs: 12, sm: size },
                        React.createElement(Section, { title: title },
                            React.createElement(Menu, { items: items }))))),
                    showPayments && (React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Payments, null))))))));
};
//# sourceMappingURL=footer.js.map